import React, { useEffect } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import {
  FormControlLabel,
  FormGroup,
  FormControl,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  isError: {
    color: theme.palette.error.main,
  },
}));

export const CheckboxField = ({
  id,
  setFieldValue,
  sequenceNumber,
  error,
  touched,
  helperText,
  format,
  label,
  value,
  ...props
}) => {
  const classes = useStyles();
  return (
    <FormControl
      fullWidth
      id={`${id}`}
      className={error ? classes.isError : null}
      error={error && touched && Boolean(error)}
    >
      <FormGroup>
        <FormControlLabel
          control={<Checkbox name="is_checked" {...props} color="primary" checked={value}/>}
          label={label}
        />
        {error && touched && Boolean(error) ? (
          <FormHelperText>{error}</FormHelperText>
        ) : null}
      </FormGroup>
    </FormControl>
  );
};
